import React from 'react';
import { components } from 'react-select';
import styles from './index.module.scss';

import { ReactComponent as CloseIcon } from 'assets/img/icons/new/close.svg';

export default function SelectClearIndicator(props) {
  return (
    <components.ClearIndicator {...props} className="p-0 mr-1">
      <CloseIcon className={styles.clearIndicator} />
    </components.ClearIndicator>
  );
}
